/**
 * Solanaland
 *
 * Author: Venus Lumanglas
 * Company: Digiteer Inc.
 *
 * https://www.digiteer.digital/
 *
 */

import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { PerformanceRateFormData } from "core/schema";
import PerformanceRateItemsForm from "./PerformanceRateItemsForm";

type PerformanceRatesProps = {
  performance_rates: Array<PerformanceRateFormData>;
};

const PerformanceRates = ({ performance_rates }: PerformanceRatesProps): JSX.Element => {
  return (
    <React.StrictMode>
      <Tabs className="card" selectedTabClassName="project-tab__link project-tab__link--active">
        <Container fluid={true}>
          <Row className="d-flex align-items-baseline">
            <Col>
              <TabList className="card__header" style={{ padding: 0 }}>
                <Col className="d-flex justify-content-start">
                  {performance_rates.map((performance_rate) => {
                    return (
                      <Tab key={performance_rate.id} data-performance-rate-id={performance_rate.id} className="project-tab__link">
                        {performance_rate.name}
                      </Tab>
                    );
                  })}
                </Col>
              </TabList>
            </Col>
          </Row>
          {performance_rates.map((performance_rate) => {
            return (
              <TabPanel key={performance_rate.id}>
                <PerformanceRateItemsForm performanceRateId={performance_rate.id} />
              </TabPanel>
            );
          })}
        </Container>
      </Tabs>
    </React.StrictMode>
  );
};

export default PerformanceRates;
